import { motion, useInView } from 'framer-motion';
import { useRef, useEffect, useState } from 'react';

const items = [
  { value: 725, prefix: '$', suffix: 'M+', label: 'Capital Deployed' },
  { value: 8400, suffix: '+', label: 'Operators Funded' },
  { value: 3, suffix: 'h', label: 'Approval Window' },
  { value: 98, suffix: '%', label: 'Renewal Rate' },
];

function Counter({ value, prefix = '', suffix = '', inView }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const dur = 1800;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.floor(value * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);
  return (
    <span>
      {prefix}
      {n.toLocaleString()}
      {suffix}
    </span>
  );
}

export default function Stats() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section
      ref={ref}
      className="relative bg-[#050505] py-24 lg:py-32 border-b border-[#c2a978]/10"
      data-testid="stats-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-14 lg:gap-y-0 gap-x-6 lg:gap-x-12">
          {items.map((it, i) => (
            <motion.div
              key={it.label}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.9, delay: i * 0.15, ease: 'easeOut' }}
              className="border-l border-[#c2a978]/20 pl-6 lg:pl-8"
              data-testid={`stat-${i}`}
            >
              <div className="font-serif text-[#c2a978] text-4xl lg:text-5xl italic leading-none">
                <Counter
                  value={it.value}
                  prefix={it.prefix}
                  suffix={it.suffix}
                  inView={inView}
                />
              </div>
              <div className="mt-5 text-[10px] tracking-[0.35em] uppercase text-[#8a8a8a]">
                {it.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
